import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';

import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { BasketService } from '../basket.service';


/* === MODEL (può essere spostato in un file dedicato) === */
export interface BasketAction {
  id: string;
  campaign_id: string;
  campaign_name: string;
  name: string;
  rule_scope: 'E' | 'F';
  status: '0' | '1';
  start_emission_date?: string;
  end_emission_date?: string;
  start_fruition_date?: string;
  end_fruition_date?: string;
  action_type?: string;
}

@Component({
  selector: 'app-basket-action-list',
  templateUrl: './basket-action-list.component.html',
  styleUrls: ['./basket-action-list.component.css'],
})
export class BasketActionListComponent implements OnInit {

  @Input() departmentList: Array<any> = [];
  @Output() departmentListSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('promoListDetailKontable')
  kontableComponent: Campaign3KontableComponent;

  /* === TABLE CONFIG === */
  paginationType: number = Campaign3KontableComponent.ServerPagination;
  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  noFilter = KontableComponent.NoFilter;
  customFilter: number = Campaign3KontableComponent.CustomFilter;

  /* === STATE === */
  basketId: string = '';
  basketActionList: BasketAction[] = [];

  breadcrumbs: Array<BreadCrumbModel> = [];
  actionStatusList: Array<{ label: string; value: string }> = [];
  scopeList: Array<{ label: string; value: string }> = [];

  translationsMap: { [key: string]: string } = {};

  showTable: boolean = false;
  showBreadCrumb: boolean = false;

  constructor(
    private notifyService: MessageService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    public basketService: BasketService
  ) {
    this.loadFilterList();
  }

  ngOnInit(): void {
    this.initBreadCrumbs();
    this.subscribeToRouteParams();

  }

  /* ===================== DATA ===================== */

  loadBasketActions(basketId: string, activeStatus: string): void {

    this.basketService.getBasketActions(basketId, activeStatus).subscribe(
      res => {
        this.basketActionList = res.data;
      },
      error => {
        console.error('Errore durante il caricamento delle azioni del basket:', error);
        this.showErrorMessage(
          this.translateService.instant('common.generic_error')
        );
      }
    );
  }

  /* ===================== ROUTING ===================== */

  private subscribeToRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      this.basketId = params['basketId'];
      if (this.basketId) {
        this.loadBasketActions(this.basketId, '1');
      }
    });
  }

  goToActionDetail(row: BasketAction): void {
    const { id, campaign_id, action_type } = row;

    if (!id || !campaign_id) {
      console.error('Parametri mancanti per la navigazione', row);
      return;
    }

    let url = `/campaign-3/${campaign_id}/${id}`;
    if (action_type === 'MSG') {
      url += '/MSG';
    }

    this.router.navigate([url]);
  }

  /* ===================== UI ===================== */

  private initBreadCrumbs(): void {
    this.translateService.get([
      'breadCrumb.baskets_list',
      'breadCrumb.basketActionList',
    ]).subscribe(translations => {
      this.breadcrumbs = [
        {
          code: 'bc1',
          description: translations['breadCrumb.baskets_list'],
          routerLink: '/baskets-list'
        },
        {
          code: 'bc2',
          description: translations['breadCrumb.basketActionList'],
          routerLink: 'basket-action-list'
        }
      ];
      this.showBreadCrumb = true;
    });
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    }
  }

  private loadFilterList(): void {
    this.translateService.get([
      'common.active',
      'common.all',
      'campaign.emission',
      'campaign.fruition'
    ]).subscribe(translations => {

      this.translationsMap = translations;

      this.actionStatusList = [
        { label: '', value: '' },
        { label: translations['common.active'], value: '1' },
        { label: translations['common.all'], value: '0' }
      ];

   this.scopeList = [
  { label: '', value: '' },
  { label: translations['campaign.emission'], value: 'emission' },
  { label: translations['campaign.fruition'], value: 'fruition' }
];

      this.showTable = true;
    });
  }

  translateState(value: string): string {
    return this.translationsMap[value === '1'
      ? 'common.active'
      : 'common.all'] || '';
  }

translateRuleScope(value: string): string {
  const key = value === 'emission' ? 'campaign.emission' 
             : value === 'fruition' ? 'campaign.fruition' 
             : '';
  return key ? (this.translationsMap[key] || '') : '';
}
  private showErrorMessage(message: string): void {
    console.warn(message);
  }

    onGoBack(){
          this.router.navigate(['/baskets-list'], {
        queryParams: { basketId: this.basketId }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-action-list/basket-action-list.component.ts